const ACCOUNT_ONLY_ROUTES = ["/app/settings/profile"];

/** Entry presentation only. Authentication, entitlement and sync keep their own gates. */
export function appEntryDestination({ signedIn, contactVerificationRequired, completed, pathname }) {
  // An uncleared session must finish its security challenge even if the browser
  // already contains anonymous onboarding preferences.
  if (contactVerificationRequired) return "/auth/sign-in";
  if (signedIn) return null;
  const accountOnly = ACCOUNT_ONLY_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
  if (accountOnly) return "/auth/sign-in";
  return completed ? null : "/onboarding";
}
